import React, { useEffect, useState } from "react";
import { Modal, Button, Upload, message, Form } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import {
  action,
  fileList,
  handleBeforeUpload,
  handleFileChanged,
  handleUpload } from
"@src/helpers/fileUpload";
import { useDispatch, useSelector } from "react-redux";
import {
  AppDispatch,
  getSlaContent,
  getSlaContentRequest,
  updateSlaContent,
  updateSlaContentClear,
  updateSlaContentRequest } from
"@src/redux";

interface SlaUpdateModalProps {
  visible: boolean;
  onCancel: () => void;
}

const SlaUpdateModal: React.FC<SlaUpdateModalProps> = ({
  visible,
  onCancel
}) => {
  const [file, setFile] = useState<File | null>(null);
  const dispatch = useDispatch<AppDispatch>();

  const { result: getSlaResult, loading: getSlaLoading } =
  useSelector(getSlaContent);
  const { result: updateSlaResult, loading: updateSlaLoading } =
  useSelector(updateSlaContent);

  const [slaPdfForm] = Form.useForm();
  const slaPdf = Form.useWatch("sla_pdf", slaPdfForm);

  const handleFileChange = (info: any) => {
    if (info.file.status === "done") {
      setFile(info.file.originFileObj);
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === "error") {
      message.error(`${info.file.name} file upload failed.`);
    }
  };

  const handleUpdate = () => {
    dispatch(
      updateSlaContentRequest({
        id: getSlaResult?.id || "",
        data: {
          url: slaPdf?.file?.url
        }
      })
    );
  };

  useEffect(() => {
    if (updateSlaResult?.status === "success") {
      onCancel();
      dispatch(updateSlaContentClear());
      dispatch(getSlaContentRequest({}));
      slaPdfForm.resetFields();
    }
  }, [updateSlaResult]);

  return (
    <Modal
      title="Update SLA Agreement"
      open={visible}
      onCancel={onCancel}
      footer={[
      <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
      <Button
        key="update"
        type="primary"
        onClick={handleUpdate}
        loading={updateSlaLoading}>
        
          Update
        </Button>]}>

      
      {/* <Upload
         action={action}
         customRequest={(e) => handleUpload(e)}
         beforeUpload={(args) => handleBeforeUpload(args, "logo")}
         onChange={(e) => handleFileChanged(e)}
         showUploadList={false}
        >
         <Button icon={<UploadOutlined />}>Choose File</Button>
        </Upload> */}
      <Form form={slaPdfForm}>
        <Form.Item name={"sla_pdf"}>
          <Upload
            action={action}
            customRequest={(e) => handleUpload(e)}
            beforeUpload={(args) => handleBeforeUpload(args, "logo", ['image/pdf'])}
            onChange={(e) => handleFileChanged(e)}>
            
            <Button icon={<UploadOutlined />}>Choose File</Button>
          </Upload>
        </Form.Item>
      </Form>
      {slaPdf?.file ?
      <p>{slaPdf?.file.filename}</p> :

      <p style={{ fontFamily: "Abel" }}>No file chosen</p>}
      
      <p style={{ marginTop: "10px", fontFamily: "Abel" }}>
        Please note this will require clients to re-accept the agreement.
      </p>
    </Modal>);

};

export default SlaUpdateModal;